var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInformation = function SvgIconInformation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#035F48",
    fillRule: "evenodd",
    d: "M11 2a9 9 0 1 0 0 18 9 9 0 0 0 0-18zM0 11C0 4.925 4.925 0 11 0s11 4.925 11 11-4.925 11-11 11S0 17.075 0 11zm13 6h-1a2 2 0 0 1-2-2v-4H9V9h1a2 2 0 0 1 2 2v4h1v2zM12 6.5a1 1 0 1 0-2 0V7a1 1 0 1 0 2 0v-.5z",
    clipRule: "evenodd"
  })));
};
export default SvgIconInformation;